<template>
  <div class="w-full">
    <img
      src="@/assets/images/sill/topView.jpg"
      class="fixed w-px h-px opacity-0 -z-10"
      alt=""
      ref="heroPic"
      @load="lhero = true"
    />
    <div
      v-if="!lhero"
      class="fixed top-0 left-0 z-50 flex items-center justify-center w-full h-screen"
    >
      <div
        class="bg-[#1B1B1B] absolute load1 top-0 left-0 w-full h-screen z-0"
      ></div>
      <div
        class="bg-[#1B1B1B] absolute load2 top-0 left-0 w-full h-screen z-0"
      ></div>
      <div class="img1">
        <img
          src="@/assets/images/miniLogo.png"
          class="z-[1] zoom img1"
          alt="Logo"
        />
      </div>
    </div>
    <section class="w-full heroBg min-h-screen relative">
      <div class="ovl absolute bottom-0 left-0 right-0 h-[12vh]"></div>
      <div class="w-[90%] max-w-xl mx-auto pt-[17vh]">
        <div class="w-full md:pl-12 pl-6 text-white">
          <h1 class="font-belgiano md:text-[80px] text-[36px]">
            Sill<span class="text-green">.</span>
          </h1>
          <p class="text-xs font-inter md:text-2xl">
            Starting from ₦{{ prcs.sill }} million
          </p>
          <div class="flex items-center gap-6 mt-3">
            <p class="text-xs font-inter md:text-lg">
              {{ downpaymentPercentage }}% down payment
            </p>
            <div class="w-px h-4 bg-realBlack"></div>
            <p class="text-xs font-inter md:text-lg">Spread over 5 years</p>
          </div>
          <router-link :to="{ name: 'order-sill' }">
            <button
              class="black-btn w-[clamp(9.375rem,5.869vw+7.174rem,15.625rem)] mt-7"
            >
              Order Now
            </button>
          </router-link>
        </div>
      </div>
    </section>
    <section class="w-full bg-realBlack">
      <div
        class="flex flex-wrap justify-between items-center md:w-[90%] w-[95%] max-w-xl mx-auto py-20 md:gap-4 gap-y-6 md:flex-nowrap"
      >
        <div class="text-center md:w-1/4 w-[50%] text-white">
          <p class="font-inter text-xs uppercase tracking-[1.25px]">
            Dimension
          </p>
          <p class="mt-1 text-sm font-inter md:text-xl">
            L: 4880 W: 1895 H: 1460
          </p>
        </div>
        <div class="w-px h-4 md:block hidden bg-white bg-opacity-40"></div>
        <div class="text-center md:w-1/4 w-[45%] text-white">
          <p class="font-inter text-xs uppercase tracking-[1.25px]">
            Top Speed
          </p>
          <p class="mt-1 text-sm font-inter md:text-xl">165km/H</p>
        </div>
        <div class="w-px h-4 md:block hidden bg-white bg-opacity-40"></div>
        <div class="text-center md:w-1/4 w-[45%] text-white">
          <p class="font-inter text-xs uppercase tracking-[1.25px]">Range</p>
          <p class="mt-1 text-sm font-inter md:text-xl">580km</p>
        </div>
        <div class="w-px h-4 md:block hidden bg-white bg-opacity-40"></div>
        <div class="text-center md:w-1/4 w-[45%] text-white">
          <p class="font-inter text-xs uppercase tracking-[1.25px]">Battery</p>
          <p class="mt-1 text-sm font-inter md:text-xl">56.8(KWh)</p>
        </div>
      </div>
    </section>
    <section class="w-full">
      <img src="@/assets/images/sill/frontend.png" class="w-full" alt="" />
    </section>
    <section class="w-full bg-realBlack md:py-[120px] py-20">
      <div class="md:w-[90%] w-[95%] max-w-xl mx-auto">
        <div
          class="md:w-[90%] w-full mx-auto flex flex-col md:flex-row items-stretch md:gap-6 gap-7"
        >
          <img
            src="@/assets/images/sill/interior.jpg"
            class="w-full md:w-3/5"
            alt=""
          />
          <div class="relative w-full md:w-2/5 tb-grad">
            <div class="md:mt-[50%]">
              <div class="relative w-full text-white md:px-4">
                <h3
                  class="capitalize font-belgiano md:text-[26px] text-[1rem] tracking-[1.4px] md:mt-4"
                >
                  Technology Meets Transportation
                </h3>
                <p class="tracking-[1.8px] mt-3 md:text-base text-xs">
                  Sill surrounds you with cutting-edge tech, featuring an
                  8.8-inch rotating screen, 15.6-inch central touchscreen, 5G &
                  wi-fi hotspot, and 20-speaker premium surround, seamlessly
                  connecting you to your journey, entertainment, and
                  surroundings.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
    <section class="w-full bg-realBlack md:py-[120px] pb-20">
      <div class="md:w-[90%] w-[95%] max-w-xl mx-auto">
        <div
          class="md:w-[90%] w-full mx-auto flex flex-col-reverse md:flex-row items-stretch md:gap-6 gap-7"
        >
          <div class="relative w-full md:w-2/5 tb-grad">
            <div class="md:mt-[50%]">
              <div class="relative w-full text-white md:px-4">
                <h3
                  class="capitalize font-belgiano md:text-[26px] text-[1rem] tracking-[1.4px] md:mt-4"
                >
                  Space to Share
                </h3>
                <p class="tracking-[1.8px] mt-3 md:text-base text-xs">
                  The Sill offers a spacious and intelligently designed trunk
                  that maximizes storage without compromising its sleek sedan
                  profile. Whether it's luggage for a weekend getaway or
                  everyday essentials, the trunk is built to handle it all with
                  ease and elegance.
                </p>
              </div>
            </div>
          </div>
          <img
            src="@/assets/images/sill/trunk.jpg"
            class="w-full md:w-3/5"
            alt=""
          />
        </div>
      </div>
    </section>
    <section class="w-full relative bg-realBlack">
      <div class="w-full relative">
        <img class="w-full" src="@/assets/images/sill/hub.jpg" alt="" />
        <div class="w-full absolute bottom-0 ovl left-0 right-0 h-[20vh]"></div>
      </div>
      <div class="md:absolute md:bottom-20 md:left-0 w-full">
        <div class="md:w-[90%] w-[95%] max-w-xl mx-auto">
          <div class="md:w-5/12 w-full md:py-0 pt-8 pb-11">
            <h3
              class="capitalize text-white font-belgiano md:text-[26px] text-[1rem] tracking-[1.4px]"
            >
              Sill: Where Form and Function Unite
            </h3>
            <p class="md:text-base text-xs tracking-[1.8px] mt-3 text-white">
              Sill's suspension bridge-inspired design commands attention on the
              road, its spacious and agile dimensions (4880mm x 1895mm x 1460mm)
              delivering a perfect blend of style and performance.
            </p>
          </div>
        </div>
      </div>
    </section>
    <section class="w-full bg-white py-20">
      <div class="md:w-[90%] w-[95%] max-w-xl mx-auto">
        <video
          src="@/assets/videos/sill/AssistedDriving.mp4"
          alt=""
          class="mx-auto"
          loop
          autoplay
          muted
        />
        <!-- <img
          src="@/assets/images/sill/blueTrans.png"
          alt=""
          class="mx-auto md:hidden block w-full"
        /> -->
        <div class="md:w-5/12 mx-auto w-full mt-8">
          <h3
            class="capitalize text-realBlack font-belgiano md:text-[26px] text-[1rem] tracking-[1.4px]"
          >
            Let Intelligence Take the Wheel.
          </h3>
          <p class="md:text-base text-xs tracking-[1.8px] mt-3 text-realBlack">
            With adaptive cruise control, intelligent risk alerts, and
            hands-free lane and ramp merging, Savannah redefines confidence
            behind the wheel. It's a car that doesn't just drive — it thinks
            ahead, so you can relax and enjoy the ride.
          </p>
        </div>
      </div>
    </section>
    <section class="w-full relative">
      <h3
        class="md:hidden w-[95%] mx-auto block capitalize text-realBlack font-belgiano md:text-[26px] text-[1rem] tracking-[1.4px] mb-3"
      >
        Unleash the Power Within
      </h3>
      <div class="w-full relative">
        <img src="@/assets/images/sill/front.png" class="w-full" alt="" />
        <div class="w-full absolute top-0 left-0 right-0">
          <div class="md:w-[90%] w-[95%] max-w-xl mx-auto md:pt-20">
            <div class="md:w-5/12 w-full">
              <h3
                class="hidden md:block capitalize text-white font-belgiano md:text-[26px] text-[1rem] tracking-[1.4px]"
              >
                Unleash the Power Within
              </h3>
              <p
                class="md:text-base text-xs tracking-[1.8px] md:mt-3 text-white"
              >
                Sill's advanced electric powertrain delivers up to 400 kW (540
                hp) and 640 Nm of torque, accelerating from 0-100 km/h in just
                3.9 seconds with a range of up to 580 km. Fast-charge from 30%
                to 80% in under 40 minutes, and experience pure, effortless
                power built for endurance and thrill.
              </p>
            </div>
          </div>
        </div>
        <div
          class="w-full hidden md:block absolute bottom-0 ovl left-0 right-0 h-[20vh]"
        ></div>
      </div>
    </section>
    <section class="w-full relative bg-realBlack">
      <div class="w-full relative md:pt-0 pt-10">
        <div
          class="w-full absolute top-0 hidden md:block ovlTop left-0 right-0 h-[20vh]"
        ></div>
        <img class="w-full" src="@/assets/images/sill/hero.jpg" alt="" />
        <div class="w-full absolute bottom-0 ovl left-0 right-0 h-[20vh]"></div>
      </div>
      <div class="md:absolute md:bottom-20 md:left-0 w-full">
        <div class="md:w-[90%] w-[95%] max-w-xl mx-auto">
          <div class="md:w-5/12 w-full md:py-0 pt-8 pb-11">
            <h3
              class="capitalize text-white font-belgiano md:text-[26px] text-[1rem] tracking-[1.4px]"
            >
              A Totally Sharp Look
            </h3>
            <p class="md:text-base text-xs tracking-[1.8px] mt-3 text-white">
              Illuminate the road with our Sill sharp look featuring an active
              rear spoiler, frameless door, fixed panoramic roof, and full LED
              head lamps and tail lamps. A dazzling design that is sure to turn
              heads.
            </p>
          </div>
        </div>
      </div>
    </section>
    <section class="bg-realBlack">
      <div class="w-[95%] max-w-[1550px] mx-auto md:pt-20 md:pb-20 pb-10 pt-8">
        <div class="w-full md:pl-8 max-w-xl mx-auto">
          <h2
            class="capitalize text-white font-belgiano text-[1rem] md:text-[56px]"
          >
            Go The Distance
          </h2>
        </div>
        <img
          src="@/assets/images/sill/distance.png"
          alt=""
          class="w-full mt-4 md:mt-8"
        />
        <div class="w-full max-w-xl mx-auto md:pl-8 md:mt-14 mt-6">
          <p
            class="md:text-base text-white text-xs tracking-[1.8px] md:mt-9 md:w-2/3 w-full"
          >
            With a single charge, it can travel up to 580 km, effortlessly
            covering long routes like Lagos to Warri (428 km) and still having
            plenty of juice left to spare. Experience the freedom to go further,
            without worrying about running out of charge.
          </p>
        </div>
      </div>
    </section>
    <section class="w-full hidden">
      <section class="w-[95%] max-w-[1550px] mx-auto md:pt-[120px] pt-9">
        <div class="w-full max-w-xl md:pl-8">
          <h2 class="capitalize font-belgiano text-[1rem] md:text-[56px]">
            View Our Spectrum
          </h2>
        </div>
      </section>
      <section class="relative w-full overflow-hidden" ref="swipeArea">
        <div
          class="absolute top-0 left-0 right-0 bottom-0 flex items-center justify-center z-[-1]"
        >
          <!-- <img
            src="@/assets/svgs/greyLogo.svg"
            class="w-full opacity-5"
            alt="Qoray"
          /> -->
          <h1
            class="w-full text-newGrey md:text-9xl text-7xl scale-125 font-belgiano font-black text-center md:scale-[2.5] opacity-5"
          >
            SILL
          </h1>
        </div>
        <div
          class="md:w-full w-[95%] mx-auto flex items-center justify-center mt-20 switchCont"
        >
          <img
            :src="spectrum[activeSpectrum].car"
            class="w-full mx-auto md:w-1/2"
            alt=""
          />
        </div>
      </section>
      <section class="w-[95%] max-w-[1550px] mx-auto md:pb-[120px] pb-9">
        <div class="w-[80%] mx-auto max-w-xl mt-9">
          <div class="flex items-center justify-center w-full">
            <div>
              <p class="text-sm text-newGrey opacity-65">Available colors</p>
              <div class="flex items-center w-full gap-3 mt-1">
                <img
                  class="w-10 h-10 overflow-hidden rounded-full cursor-pointer"
                  :class="[
                    activeSpectrum === index ? 'border-[3px] border-green' : '',
                  ]"
                  v-for="(col, index) in spectrum"
                  :key="index"
                  :src="col.icon"
                  @click="changeCarTo(index)"
                  alt=""
                />
              </div>
            </div>
          </div>
        </div>
      </section>
    </section>
    <section class="w-[95%] max-w-[1550px] mx-auto py-[60px]">
      <div class="md:w-[80%] w-full mx-auto max-w-xl">
        <div class="w-full">
          <div class="w-full">
            <h6 class="text-lg font-belgiano md:text-2xl mb-2">Specs</h6>
            <div
              class="flex md:grid md:grid-cols-3 items-start flex-wrap w-full justify-between gap-y-4 md:gap-8"
            >
              <div
                v-for="spec in showAll ? specs : specs.slice(0, 6)"
                :key="spec.title"
                class="w-fit md:min-w-fit min-w-[50%] px-2 py-1 md:px-5 md:py-4"
              >
                <p
                  class="w-full text-sm text-newGrey whitespace-nowrap opacity-65"
                >
                  {{ spec.title }}
                </p>
                <p class="w-full whitespace-nowrap text-realBlack">
                  <!-- <br /> -->
                  {{ spec.value }}
                </p>
              </div>
            </div>
          </div>
          <div class="w-full" v-if="showAll">
            <div
              class="w-full mt-8"
              v-for="other in otherSpecs"
              :key="other.title"
            >
              <h6 class="text-lg font-belgiano md:text-2xl mb-2">
                {{ other.title }}
              </h6>
              <div
                class="flex flex-wrap items-start w-full gap-4 pl-2 mt-2 md:px-7 md:pl-0 md:gap-8"
              >
                <div
                  class="vehSpec"
                  v-for="otherValue in other.values"
                  :key="otherValue"
                >
                  <span class="bigDot"></span>
                  <p>{{ otherValue }}</p>
                </div>
              </div>
            </div>
            <div class="w-full">
              <div class="px-2 py-4 mt-3">
                <p class="text-lg">
                  <span class="text-sm text-newGrey opacity-65">Warranty</span>
                  <br />
                  36 Months
                </p>
              </div>
              <div class="w-full mt-3">
                <div class="inline-block py-2 pl-3 pr-4 bg-green bg-opacity-10">
                  <p class="font-inter leading-[26px] text-green">
                    Home charging available
                  </p>
                </div>
              </div>
            </div>
          </div>
          <div class="w-full">
            <button
              v-if="!showAll"
              @click="showAll = true"
              class="black-btn long mt-7"
            >
              See More
            </button>
            <div class="flex items-center justify-between w-full" v-else>
              <router-link :to="{ name: 'order-sill' }">
                <button class="black-btn long mt-7">Order Now</button>
              </router-link>
              <button
                class="white-btn long mt-7 black-border"
                @click="showAll = false"
              >
                See Less
              </button>
            </div>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import gsap from "gsap";
import col1 from "@/assets/images/savannah/colors/night_black.png";
import col2 from "@/assets/images/savannah/colors/cornet_white.png";
import col3 from "@/assets/images/savannah/colors/particle_blue.png";
import col4 from "@/assets/images/savannah/colors/dust-free_silver.png";
import car1 from "@/assets/images/savannah/colors/black.png";
import car2 from "@/assets/images/savannah/colors/white.png";
import car3 from "@/assets/images/savannah/colors/blue.png";
import car4 from "@/assets/images/savannah/colors/silver.png";
export default {
  data() {
    return {
      lhero: false,
      showAll: false,
      swipe: {
        touchstartX: 0,
        touchendX: 0,
      },
      specs: [
        { title: "Range (km)", value: "580" },
        { title: "Charging Time", value: "Fast charging 0.27 hours" },
        { title: "Fast Charging Capacity (%)", value: "30-80" },
        { title: "Maximum Power (kW)", value: "200 (272Ps)" },
        { title: "Maximum Torque (N·m)", value: "310" },
        { title: "Motor Type", value: "Permanent magnet/synchronous" },
        {
          title: "Gearbox",
          value: "Electric vehicle single-speed transmission",
        },
        { title: "Length x Width x Height (mm)", value: "4880x1895x1460" },
        { title: "Wheelbase (mm)", value: "2915" },
        { title: "Front Wheelbase (mm)", value: "1620" },
        { title: "Rear Track (mm)", value: "1630" },
        { title: "Curb Mass (kg)", value: "1852" },
        { title: "Full Load Mass (kg)", value: "2279" },
        { title: "Luggage Compartment Volume (L)", value: "452-1026" },
        { title: "Minimum Turning Radius", value: "5.6m" },
        { title: "Drag Coefficient (Cd)", value: "0.209" },
        { title: "Maximum Speed (km/h)", value: "171" },
        { title: "0-100km/h Acceleration Time (s)", value: "5.7" },
        { title: "Power Consumption (kWh/100km)", value: "12.6" },
        { title: "Battery Type", value: "Lithium iron phosphate battery" },
        { title: "Battery Capacity (kWh)", value: "56.8" },
        { title: "Battery Technology", value: "Mach Battery" },
        { title: "Fast Charging Port Location", value: "Left fuel tank" },
        { title: "VTOL Mobile Power Station", value: "3.3kW" },
        { title: "Drive Mode", value: "Rear-engine, rear-wheel drive" },
        {
          title: "Front Suspension Type",
          value: "McPherson independent suspension",
        },
        {
          title: "Rear Suspension Type",
          value: "Multi-link independent suspension",
        },
        { title: "Steering Type", value: "Electric power steering" },
        { title: "Front Brake Type", value: "Ventilated disc type" },
        { title: "Rear Brake Type", value: "Solid disc" },
        { title: "Parking Brake Type", value: "Electronic parking brake" },
        { title: "Front Tyre Specifications", value: "235/50 R18" },
        { title: "Rear Tyre Specifications", value: "235/50 R18" },
      ],
      otherSpecs: [
        {
          title: "Active Safety",
          values: [
            "ABS anti-lock braking system",
            "Braking force distribution (EBD/CBC, etc.)",
            "Brake assist (EBA/BA, etc.)",
            "Traction control (TCS/ASR, etc.)",
            "Vehicle stability system (ESP/DSC, etc.)",
            "Lane Departure Warning",
            "Forward Collision Warning",
            "Rear Collision Warning",
            "Reversing side warning",
            "DOW door opening warning",
            "Traffic ahead warning",
            "Braking for crossing traffic ahead",
            "Active braking",
            "Lane change assistance",
            "Lane Keeping Assist System",
            "Lane centering",
            "Fatigue driving tips",
            "Active DMS fatigue detection",
            "Road traffic sign recognition",
          ],
        },
        {
          title: "Passive Safety",
          values: [
            "Front airbags: Main driver's seat + co-pilot seat",
            "Side airbags: front row",
            "Side curtain airbags",
            "Seat belt not fastened reminder",
            "Tyre pressure monitoring system: Tyre pressure display",
            "Child seat interface (ISOFIX)",
          ],
        },
        {
          title: "Auxiliary/Control Configuration",
          values: [
            "Parking radar: forward + back",
            "Front vehicle departure reminder",
            "Driving assistance images: Reversing image, 360° panoramic images, Transparent images",
            "Cruise control system: Cruise control, Adaptive cruise control, Full-speed adaptive cruise control",
            "Automatic Lane Change Assist",
            "Automatic exit/entry of ramp",
            "Navigation-assisted driving: Expressway section",
            "Assisted driving level: Level 2",
            "Automatic parking",
            "Track reverse",
            "Memory Parking",
            "Automatic parking (AUTOHOLD)",
            "Hill Start Assist (HAC)",
            "Hill Descent Control (HDC)",
          ],
        },
        {
          title: "Driving Mode",
          values: [
            "Sports",
            "Personalization",
            "ECO/Economy",
            "Standard comfort",
            "Braking Energy Regeneration System",
            "Comfort braking",
            "Low speed driving warning sound",
          ],
        },
        {
          title: "External Configuration",
          values: [
            "Skylight Type: The panoramic sunroof cannot be opened",
            "Active closed grille",
            "Aluminum alloy wheels",
            "Frameless design doors",
            "Hidden door handles",
          ],
        },
        {
          title: "Internal Configuration",
          values: [
            "Steering wheel material: cortex / Genuine Leather",
            "Steering wheel adjustment: Up and down + front and back",
            "Steering wheel functions: Multi-function control, heating",
            "Gear shifting: Electronic hand gear shift",
            "Trip computer screen: color",
            "LCD instrument style: Full LCD",
            "LCD instrument size (inches): 10.25",
            "Electric tailgate",
            "Electric tailgate position memory",
            "Central locking system in the car",
            "Remote control key type: Smart remote control key, Mobile Bluetooth Key",
            "Keyless entry: Main driver's seat",
            "Keyless start",
            "Remote Start",
            "Remote control mobile vehicle",
            "Head-up display (HUD)",
            "HUD projection size (inches): 10.9",
            "Built-in driving recorder",
            "Mobile phone wireless charging",
            "Maximum power of mobile phone wireless charging (W): 50",
          ],
        },
        {
          title: "Seat Configuration",
          values: [
            "Seat material: imitation leather",
            "Electric seat adjustment: Main driver's seat + co-pilot seat",
            "Overall adjustment of the driver's seat: Move forward and backward, Backrest angle, Height adjustment",
            "Local adjustment of the driver's seat: waist",
            "Passenger seat overall adjustment: Move forward and backward, Backrest angle",
            "Front seat functions: heating, ventilation, Memory (main driver), Massage (driver's seat)",
            "Front/rear armrests: front row + back row",
            "Rear cup holder",
            "Rear seat folding ratio: Fold the entire row",
          ],
        },
        {
          title: "Smart Connectivity",
          values: [
            "Central control screen size (inches): 15.6",
            "Central control screen material: LCD",
            "Center console color screen resolution: 2.5K",
            "Satellite navigation system",
            "Navigation traffic information display",
            "Map Brand: Gaode",
            "Roadside assistance service",
            "Bluetooth/car phone, CarPlay",
            "Mobile Internet Mapping: Carlink",
            "Internet of Vehicles: HUAWEI HiCar, Standard",
            "4G/5G network: 4G",
            "OTA upgrade",
            "Facial Recognition",
            "Voice recognition control system",
            "Voice wake-up function",
            "Voice wake-up recognition function by region: Main driver + co-pilot",
            "Continuous speech recognition",
            "Seeing is telling",
            "Wi-Fi hotspots",
          ],
        },
        {
          title: "Audio and Video Entertainment",
          values: [
            "App Store",
            "Multimedia Interface: USB/Type-C",
            "Number of USB/Type-C ports: 2 in the front row + 2 in the back row",
            "USB/Type-C maximum charging power: Front row 18W, Back row 18W",
            "Simulated sound waves",
            "Number of speakers: 19",
            "Seat speakers (headrest/shoulder)",
          ],
        },
        {
          title: "Lighting Configuration",
          values: [
            "Low beam: led",
            "High beam: led",
            "Daytime running lights",
            "Automatic headlights",
            "Headlight height adjustment",
            "Interior ambient lighting: 64 colors",
            "Active ambient lighting",
            "Headlights delayed off",
          ],
        },
        {
          title: "Glass/Rearview Mirror",
          values: [
            "Power windows: front row + back row",
            "One-touch window lift: whole vehicle",
            "Window anti-pinch function",
            "Exterior rearview mirror function: Electric adjustment, heating, Electric folding, Automatic folding when locking the car",
            "Car makeup mirror: Main driving seat + lighting, Passenger seat + lighting",
            "Rain-sensing wipers",
          ],
        },
        {
          title: "Air Conditioning/Refrigerator",
          values: [
            "Air conditioning control method: automatic",
            "Rear air outlet",
            "In-car PM2.5 filter",
          ],
        },
        {
          title: "Intelligent Configuration",
          values: [
            "Assisted driving operating system: eπ PILOT",
            "In-vehicle intelligent system: eπ OS",
            "In-vehicle smart chip: Qualcomm Snapdragon 8155",
            "Vehicle system memory (GB): 12",
            "Vehicle system storage (GB): 128",
            "Mobile App remote control: Remote Control, Charging Management, Service Appointment",
            "Heat pump management system",
          ],
        },
        {
          title: "Sensors & Cameras",
          values: [
            "Number of external cameras: 11",
            "Number of cameras in the car: 1",
            "Number of ultrasonic radars: 12",
            "Number of millimeter-wave radars: 4",
            "Sub-meter high-precision positioning system",
            "High-precision maps",
            "Sentinel (Clairvoyance) Mode",
          ],
        },
        {
          title: "Battery/Charging",
          values: [
            "Battery Temperature Management: Low temperature heating, Liquid cooling",
            "Fast charging port location: Left fuel tank",
            "Slow charging port location: Left fuel tank",
          ],
        },
        {
          title: "Safety",
          values: [
            "Electronic Stability Control (ABS/EBD/EBA)",
            "Traction Control (ASR/TCS/TRC, etc.)",
            "Hill Start Assist (HAC)",
            "Hill Descent Control (HDC)",
            "Driver/Passenger Front Airbags",
            "Front Side Airbags",
            "Front/Rear Head-position Air Curtain",
            "Direct Tyre Pressure Monitoring System",
            "Pre-tensioned Force Limiting Seatbelt",
            "Front  Seatbelt Unfastened Reminder",
            "Rear Seatbelt Unfastened Reminder",
            "Second-Row Child Seat Interfaces  With ISOFIX/LATCH",
            "Electric Child Safety Locks",
            "Parking Radar (Front/Back)",
            "Rear View Camera with Trajectory Guide Line",
          ],
        },
        {
          title: "Advanced Driving Assistance System",
          values: [
            "Ultrasonic Radar",
            "Around View Camera",
            "Cruise Control (CC)",
            "4G",
            "Hidden Type Instrument Panel",
            "17.6-inch Central Control Screen",
            "12 Speakers",
            "Bluetooth Music/Call",
          ],
        },
      ],
      spectrum: [
        {
          icon: col1,
          car: car1,
        },
        {
          icon: col2,
          car: car2,
        },
        {
          icon: col3,
          car: car3,
        },
        {
          icon: col4,
          car: car4,
        },
      ],
      activeSpectrum: 0,
    };
  },
  computed: {
    downpaymentPercentage() {
      return this.$store.getters.downPayment;
    },
    mobile() {
      return window.innerWidth <= 768;
    },
    prcs() {
      return this.$store.getters.dispPrices;
    },
  },
  methods: {
    handleSwipe() {
      if (this.swipe.touchendX < this.swipe.touchstartX) {
        if (this.activeSpectrum < this.spectrum.length - 1) {
          this.changeCarTo(this.activeSpectrum + 1);
        }
      }
      if (this.swipe.touchendX > this.swipe.touchstartX) {
        if (this.activeSpectrum > 0) {
          this.changeCarTo(this.activeSpectrum - 1, true);
        }
      }
    },
    async changeCarTo(index, reverse = false) {
      const changeTo = async (index) => {
        this.activeSpectrum = index;
      };
      if (reverse) {
        if (this.activeSpectrum !== 0) {
          gsap.to(".switchCont", {
            xPercent: 110,
            duration: 0.4,
            ease: "Power4.in",
            async onComplete() {
              await changeTo(index);
              gsap.set(".switchCont", {
                xPercent: -110,
                onComplete() {
                  gsap.to(".switchCont", {
                    xPercent: 0,
                    duration: 0.6,
                    ease: "Power4.out",
                  });
                },
              });
            },
          });
        }
      } else {
        if (this.activeSpectrum !== index) {
          gsap.to(".switchCont", {
            xPercent: -110,
            duration: 0.4,
            ease: "Power4.in",
            async onComplete() {
              await changeTo(index);
              gsap.set(".switchCont", {
                xPercent: 110,
                onComplete() {
                  gsap.to(".switchCont", {
                    xPercent: 0,
                    duration: 0.6,
                    ease: "Power4.out",
                  });
                },
              });
            },
          });
        }
      }
    },
  },
  watch: {
    lhero() {
      if (this.lhero === true) {
        this.$refs.swipeArea.addEventListener("touchstart", (e) => {
          this.swipe.touchstartX = e.changedTouches[0].screenX;
        });
        this.$refs.swipeArea.addEventListener("touchend", (e) => {
          this.swipe.touchendX = e.changedTouches[0].screenX;
          this.handleSwipe();
        });
      }
    },
  },
};
</script>

<style>
.heroBg {
  background-image: url("@/assets/images/sill/topView.jpg");
  background-size: cover;
  background-position: center;
}
@media (max-width: 768px) {
  .heroBg {
    background-position: 72%;
  }
}
.ovl {
  background: linear-gradient(0deg, #000000 0%, rgba(0, 0, 0, 0) 100%);
}
.ovlTop {
  background: linear-gradient(0deg, rgba(0, 0, 0, 0) 0%, #000000 100%);
}
.vehSpec {
  @apply flex items-center gap-3 md:w-auto w-full;
}
.bigDot {
  @apply inline-block w-2 h-2 rounded-full bg-green bg-opacity-65;
}
</style>